// https://css-tricks.com/the-trick-to-viewport-units-on-mobile/

let throttleTimeout

function updateVhButNotTooOften () {
  clearTimeout(throttleTimeout)
  throttleTimeout = setTimeout(updateVh, 50)
}

function updateVh () {
  const vh = window.innerHeight * 0.01

  const innerHTML = `
    :root {
      --vh: ${vh}px;
    }
  `

  const existingStyleTag = document.getElementById('dynamic-vh')
  if (existingStyleTag) {
    existingStyleTag.innerHTML = innerHTML
  } else {
    const newStyleTag = document.createElement('style')
    newStyleTag.id = 'dynamic-vh'
    newStyleTag.innerHTML = innerHTML
    document.head.append(newStyleTag)
  }
}

window.addEventListener('resize', updateVhButNotTooOften)
updateVh()
